import { Component } from '@angular/core';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangePasswordComponent } from '@app/components/customer-login/change-password.component';
import { ForgetPasswordComponent } from '@app/components/customer-login/forgot-password/forgetpassword.component';
import { LoginComponent } from '@app/components/customer-login/login.component';
import { NotFoundComponent } from '@app/components/common/not-found/not-found.component';
import { FleetCustomerRegistrationComponent } from '@app/components/customer-registration/fleet-customer-register.component';
import { RetailCustomerRegisterComponent } from '@app/components/customer-registration/retail-customer-register.component';
import { CustomerPreloginComponent } from '@app/components/customer-pre-login/pre-login.component';
import {FAQComponent} from '@app/components/customer-pre-login/faq/faq.component';
import { TermsAndConditionsComponent} from '@app/components/customer-pre-login/termsandconditions/termsandconditions.component';
import { ResetPasswordComponent } from './components/customer-login/resetPassword.component';
import { PermissionsGuard, AuthGuard } from './services/shared/auth.guard';
import { WalletAggregatorComponent } from './components/customer-pre-login/wallet-aggregator/wallet-aggregator.component';
import { OutletsComponent } from './components/customer-pre-login/outlets/outlets.component';
export const Route: Routes = [
        { path: '', redirectTo: 'pre-login', pathMatch: 'full' },
        { path: 'pre-login', component: CustomerPreloginComponent },
        { path: 'igloutlets', component: OutletsComponent },
        // { path: 'WalletAggregator', component: WalletAggregatorComponent },
        //{ path: 'pre-login/:id', component: CustomerPreloginComponent },
        // { path: '', redirectTo: 'login', pathMatch: 'full' },
        // { path: 'login', component: LoginComponent },
        //{ path: 'ChnagePassword', component: ChangePasswordComponent },
        //{ path: 'resetPassword', component: ResetPasswordComponent },
        //{ path: 'fleetCustomerRegister', component: FleetCustomerRegistrationComponent },
        //{ path: 'retailCustomerRegister', component: RetailCustomerRegisterComponent },
        //{ path: 'faq', component: FAQComponent },
        //{ path: 'termsandconditions', component: TermsAndConditionsComponent },
        //{ path: 'forgotpassword', component: ForgetPasswordComponent},
        {
                path: 'profile',
                // Loading by relative path didn't seem to work here
                loadChildren: './components/customer-home/home.module#HomeModule',
              //  canActivate: [AuthGuard,PermissionsGuard]
                
        },
        {
                path: 'merchant',
                // Loading by relative path didn't seem to work here
                loadChildren: './components/merchant-home/merchantHome.module#HomeModule',
               // canActivate: [AuthGuard,PermissionsGuard]
                
        },
        {
                path: 'app',
                // Loading by relative path didn't seem to work here
                loadChildren: './components/merchant-home/merchantHome.module#HomeModule',
              //  canActivate: [AuthGuard,PermissionsGuard]
        }
        ,
        {
                path: 'secure',
                // Loading by relative path didn't seem to work here
                loadChildren: './components/admin-home/adminHome.module#AdminHomeModule',
                //canActivate: [AuthGuard,PermissionsGuard]
        },
        { path: 'notfound', component: NotFoundComponent },
        { path: '**', redirectTo: 'notfound' }
        
];

@NgModule({
        imports: [RouterModule.forRoot(Route, { onSameUrlNavigation: 'reload' })],
        exports: [RouterModule],
        providers: []
})
export class MainRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routes.ts